/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormRecordUnknownFieldComponent } from '../../admin/form/form-record/fields/unknown/form-record-unknown-field.component';
import { Form } from '../../lib/form/form.service';
/* eslint-enable */

export class FormRecordUnknownFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private selector: Form.FieldDataTypeSelector,
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordUnknownFieldComponent)
      .create(this.injector);
    cmp.instance.setFieldDataTypeSelector(this.selector);
    return cmp;
  }

}
